export const Loading = ({ what = "data" }: { what?: string }) => (
  <div className="state" role="status">Loading {what}…</div>
);

export const Empty = ({ title, hint }: { title: string; hint?: string }) => (
  <div className="state">
    <strong>{title}</strong>
    {hint}
  </div>
);

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="state state-error" role="alert">
      <strong>Could not load this</strong>
      {message}
      {onRetry ? (
        <div style={{ marginTop: 12 }}>
          <button onClick={onRetry}>Retry</button>
        </div>
      ) : null}
    </div>
  );
}

/** Sequential single-hue magnitude bar, for share-of-total inside a table. */
export function Bar({ value, max }: { value: number; max: number }) {
  const pct = max > 0 ? Math.min(100, (value / max) * 100) : 0;
  return (
    <div className="bar-track" role="presentation">
      <div className="bar-fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
